import { trapFocus } from '../modules/slideoutFocusTrap';

/** Mobile menu hierarchy handling */
export default class MobileMenu {
  constructor(theme, element) {
    this.theme = theme;
    this.element = element;

    this.menuStructure = JSON.parse(document.querySelector('#mobile-menu-data').textContent);
    this.menuStructureTopbar = JSON.parse(document.querySelector('#mobile-menu-data-topbar').textContent);
    this.themeMenuID = 'theme-menu';
    this.topmenu = this.element.querySelector('#mobile-menu--main-menu');
    this.menu = this.element.querySelector('#mobile-menu');
    this.submenu = this.element.querySelector('#mobile-submenu');
    this.lastClickedItem = null;

    this.element.querySelectorAll('.mobile-menu-sub').forEach(el => {
      el.removeEventListener('click', this.menuClick, true);
      el.addEventListener('click', this.menuClick(el, this.menu), true);
    });

    this.element.querySelectorAll('.mobile-menu-back').forEach(backBtn => {
      this.cloneBackBtn(backBtn, this.topmenu);
    });
  }

  cloneBackBtn = (back_btn, parent_menu) => {
    // Cloning removes all existing event listeners more reliably than removing named function with removeEventListener
    var oldBtn = back_btn;
    var newBtn = oldBtn.cloneNode(true);

    newBtn.addEventListener('click', this.backClick(newBtn, parent_menu), true);
    oldBtn.parentNode.replaceChild(newBtn, oldBtn);
  }

  menuHandle = (link, handle) => {
    return link.classList.contains('sub-topbar') ? this.menuStructureTopbar[handle] : this.menuStructure[handle];
  }

  removeAllMenuTabindex = () => {
    var allMenuLinks = document.querySelectorAll('.mobile-menu .mobile-menu-link');
    allMenuLinks.forEach(el => {
      el.setAttribute('tabIndex', '-1')
    });
  }

  setTabindex0 = (els) => {
    els.forEach(el => {
      el.setAttribute('tabIndex', '0');
    })
  }

  linksTabbable = (activeMenu, trapFocus) => {
    /**
    * @todo function is pretty disgusting and could do with a rewrite
    */
    this.removeAllMenuTabindex();
    var listLinks;

    if (this.menuHasBackButton(activeMenu)) {
      var backBtn = activeMenu.querySelectorAll(':scope > .mobile-menu-back');
      this.setTabindex0(backBtn);
    }

    if (this.menuIsUl(activeMenu)) {
      listLinks = activeMenu.querySelectorAll(':scope > li > .mobile-menu-link')
    }

    if (this.menuHasUlChild(activeMenu)) {
      listLinks = activeMenu.querySelectorAll(':scope > ul:not(.sm-icons) > li > .mobile-menu-link');
    }

    if (this.menuHasFieldsetChild(activeMenu)) {
      listLinks = activeMenu.querySelectorAll(':scope > .mobile-menu__fieldset > .mobile-menu-link');
    }

    if (listLinks) {
      this.setTabindex0(listLinks);
    }

    trapFocus(this.themeMenuID);
  }

  menuIsUl = (menu) => {
    return menu.tagName == 'UL';
  }

  menuHasUlChild = (menu) => {
    return menu.querySelectorAll(':scope > ul:not(.sm-icons)').length;
  }

  menuHasBackButton = (menu) => {
    return menu.querySelectorAll(':scope > .mobile-menu-back').length;
  }

  menuHasFieldsetChild = (el) => {
    return el.querySelectorAll(':scope > .mobile-menu__fieldset').length;
  }

  clearSubmenus = (menu) => {
    menu.querySelectorAll(':scope > li').forEach((el, i) => {
      if (i == 0) return;

      el.remove();
    });
  };

  backClick = (backBtn, parent_menu) => {
    backBtn.addEventListener('click', (e) => {
      e.target.closest('.mobile-menu').classList.add('mobile-menu-hidden');
      e.target.closest('.mobile-menu').classList.remove('active');

      parent_menu.classList.add('active');

      var liArray = Array.from(parent_menu.children);
      liArray.forEach(li => {
        if (li.querySelector('button')) {
          li.querySelector('button').setAttribute('aria-expanded', 'false');
        }
      })

      this.linksTabbable(parent_menu, trapFocus);
      if (this.lastClickedItem) this.lastClickedItem.focus();
    })
  };

  stringToHTML = (str) => {
    var parser = new DOMParser();
    var doc = parser.parseFromString(str, 'text/html');

    return doc.body.children.item(0);
  }

  createMenuButton = (link, linkMenuStructure) => {
    const btn = `<button class="alt-focus mobile-menu-sub mobile-menu-link">${linkMenuStructure.title}<i data-feather="chevron-right" aria-hidden="true"></i></button>`;
    const btnHTML = this.stringToHTML(btn);

    btnHTML.setAttribute('aria-expanded', 'false');
    btnHTML.setAttribute('data-link', link);

    /**
    * @todo - this is getting highlighted with an error for some reason, need to fix:
    */
    // @ts-ignore
    btnHTML.addEventListener('click', this.menuClick(btnHTML, this.submenu));
    return btnHTML;
  }

  createMenuLink = (linkMenuStructure) => {
    const linkEl = document.createElement('a');

    linkEl.classList.add('alt-focus', 'mobile-menu-link');
    linkEl.setAttribute('href', linkMenuStructure.url);
    linkEl.innerText = linkMenuStructure.title;

    return linkEl;
  }

  insertChildNav = (menuWrapper, clickedItem) => {
    const self = this;

    return new Promise(resolve => {
      setTimeout(() => {
        const backBtn = menuWrapper.querySelector('.mobile-menu-back');
        const parentMenu = self.lastClickedItem.closest('.mobile-menu');

        clickedItem.parentNode.insertBefore(menuWrapper, clickedItem.nextSibling);
        self.cloneBackBtn(backBtn, parentMenu);

        resolve();
      }, 100);
    });
  }

  menuClick = (el, menu) => {
    var self = this;

    el.addEventListener('click', function (e) {
      var menuWrapper = menu.closest('.mobile-menu');
      var clickedItem = e.currentTarget;
      var handle = clickedItem.dataset.link;
      self.lastClickedItem = clickedItem;

      clickedItem.setAttribute('aria-expanded', 'true');
      document.querySelector('.mobile-menu.active').scrollTop = 0;
      document.querySelectorAll('.mobile-menu').forEach(menu => menu.classList.remove('active'));
      self.clearSubmenus(menu);

      if (handle === 'mobile-menu-currency' || handle === 'mobile-menu-locale') {
        menuWrapper = document.querySelector(`#${handle}`);
        menuWrapper.classList.remove('mobile-menu-hidden');
        menuWrapper.classList.add('active');
        self.linksTabbable(menuWrapper, trapFocus);

        return;
      }

      menuWrapper.classList.add('active');

      var getMenuStructure = self.menuHandle(clickedItem, handle);
      const isTopBar = el.classList.contains('sub-topbar');

      if (getMenuStructure) {
        getMenuStructure.links.forEach((link) => {
          var linkMenuStructure = self.menuHandle(clickedItem, link);
          var liElement = document.createElement('li');
          var linkHasChildren = linkMenuStructure.links.length > 0;

          if (linkHasChildren) {
            var menuBtn = self.createMenuButton(link, linkMenuStructure);
            if (isTopBar) menuBtn.classList.add('sub-topbar');
            liElement.append(menuBtn);
          } else {
            var menuLink = self.createMenuLink(linkMenuStructure);
            liElement.append(menuLink);
          }

          menu.append(liElement);
        });

        var topMenuItem = menu.querySelector('.top-link');
        topMenuItem.innerText = getMenuStructure.title;
        topMenuItem.setAttribute('href', getMenuStructure.url);
      }

      async function updateUI() {
        await self.insertChildNav(menuWrapper, clickedItem);

        self.linksTabbable(menuWrapper, trapFocus);
        menuWrapper.classList.remove('mobile-menu-hidden');
      }

      updateUI();

      self.theme.loadIcons();
    }, false);
  };
}
